// extracted by mini-css-extract-plugin
export default {"disclaimer":"Disclaimer_disclaimer__V-t6l","fullDisclaimer":"Disclaimer_fullDisclaimer__UwgJn"};